// ProfileStaffSkeleton — mirrors the real staff card so the swap doesn't jump.
// Shares the staff page's skeleton pieces; only the edit chrome is added here.
import "../../staffPage/staffSkeleton/staffPageSkeleton.css";
import "./profileStaffSkeleton.css";

const ProfileStaffSkeleton = () => {
	return (
		<div className="sf-staff-page sf-stf-page sf-staff-skel">
			<div className="sf-staff-content">
				<div className="sf-staff-main">
					<div className="sf-skel-box sf-skel-gallery" />

					<div className="sf-skel-head">
						<div className="sf-skel-box sf-skel-avatar" />
						<div className="sf-skel-head-copy">
							<div className="sf-skel-box sf-skel-eyebrow" />
							<div className="sf-skel-title-row">
								<div className="sf-skel-box sf-skel-title" />
								<div className="sf-skel-box sf-skel-edit" />
							</div>
							<div className="sf-skel-pills">
								<div className="sf-skel-box sf-skel-pill" />
								<div className="sf-skel-box sf-skel-pill" />
							</div>
							<div className="sf-skel-box sf-skel-shop" />
							<div className="sf-skel-box sf-skel-subtitle" />
						</div>
					</div>

					<div className="sf-skel-box sf-skel-bio" />

					<div className="sf-skel-section-head sf-skel-section-head--edit">
						<div className="sf-skel-box sf-skel-h2" />
						<div className="sf-skel-box sf-skel-edit" />
					</div>

					<div className="sf-skel-card">
						<div className="sf-skel-card-head">
							<div className="sf-skel-box sf-skel-cat" />
						</div>
						{Array.from({ length: 4 }).map((_, i) => (
							<div className="sf-skel-row" key={i}>
								<div className="sf-skel-row-copy">
									<div className="sf-skel-box sf-skel-line-lg" />
									<div className="sf-skel-box sf-skel-line-sm" />
								</div>
								<div className="sf-skel-box sf-skel-price" />
							</div>
						))}
					</div>
				</div>

				<div className="sf-staff-sidebar">
					<div className="sf-skel-card sf-skel-aside">
						<div className="sf-skel-box sf-skel-map" />
						<div className="sf-skel-aside-body">
							<div className="sf-skel-box sf-skel-line-lg" />
							<div className="sf-skel-box sf-skel-line-sm" />
							<div className="sf-skel-box sf-skel-cta" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProfileStaffSkeleton;
